<template>
  <div>
    <!-- Header -->
    <div
      class="header pb-8"
      style="background-image: url(img/theme/hero-bg.jpg);"
    >
      <b-nav align="right" class="mb-3" style="background-color: #ffffff7a">
        <b-nav-item to="/" class="text-primary mr-3"
          ><i class="far fa-home"></i> Inicio</b-nav-item
        >
      </b-nav>
      <!-- <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-lead text-white">Use these awesome forms to login or create new account in your project for
                free.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>-->
      <b-container>
        <b-row class="justify-content-center">
          <b-col class="text-center">
            <b-img fluid src="img/brand/nuevo_logo.svg" width="200px"></b-img>
          </b-col>
        </b-row>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-info" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--7 pb-5" fluid>
      <b-row class="justify-content-center">
        <b-col lg="10" md="12">
          <b-card no-body class="border-0 mb-0">
            <b-card-body v-if="download.uuid">
              <h2 class="text-center">
                Tu factura ha sido enviada a tu correo
                <strong>{{ receptor.email }}</strong>
              </h2>
              <div class="d-block text-center">
                <a
                  :href="
                    `http://192.168.100.13:5000/api/facturacion/descargar/${download.uuid}`
                  "
                  download
                  class="text-dark btn btn-success btn-sm"
                  ><i class="far fa-download"></i> Descargar factura</a
                >
              </div>
            </b-card-body>
            <b-card-body v-if="!download.uuid" class="px-lg-3 py-lg-3">
              <b-alert v-if="error.length" show variant="danger">
                <span v-for="(e, k) in error" :key="k">{{ e }}</span>
              </b-alert>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <!-- <b-row>
                    <b-col>
                      <b-form-group
                        class="col-md-4 float-right text-right"
                      >
                        <base-checkbox v-model="params.remember">Recordar Configuración</base-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row> -->

                  <b-row>
                    <b-col md="12" class="d-flex justify-content-between">
                      <h4 class="text-primary">Mis Datos Fiscales</h4>
                      <base-checkbox v-model="remember"
                        >Recordar Configuración</base-checkbox
                      >
                    </b-col>
                    <b-form-group
                      class="col-md-4 mb-3"
                      label-class="pb-1"
                      label="Nombre"
                    >
                      <b-form-input
                        size="sm"
                        type="text"
                        placeholder="Nombre"
                        @change="configStore"
                        class="text-uppercase form-control-solid"
                        v-model="receptor.nombre"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      class="col-md-4 mb-3"
                      label-class="pb-1"
                      label="RFC"
                    >
                      <b-form-input
                        size="sm"
                        type="text"
                        placeholder="RFC"
                        @change="configStore"
                        class="text-uppercase form-control-solid"
                        v-model="receptor.rfc"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      class="col-md-4 mb-3"
                      label-class="pb-1"
                      label="Email"
                    >
                      <b-form-input
                        size="sm"
                        type="text"
                        placeholder="Email"
                        @change="configStore"
                        class="text-lowercase form-control-solid"
                        v-model="receptor.email"
                      ></b-form-input>
                    </b-form-group>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <h4 class="text-primary">Parámetros CFDI</h4>
                    </b-col>
                    <b-form-group
                      class="col-md-4 mb-3"
                      label-class="pb-1"
                      label="Uso CFDI"
                    >
                      <b-form-select
                        v-model="cfdi.uso"
                        size="sm"
                        @change="configStore()"
                      >
                        <b-form-select-option value="G03"
                          >Gastos en General</b-form-select-option
                        >
                        <b-form-select-option value="P01"
                          >Por Definir</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="col-md-4 mb-3"
                      label-class="pb-1"
                      label="Tipo Consumo"
                    >
                      <b-form-select
                        v-model="cfdi.tipo"
                        size="sm"
                        @change="configStore()"
                      >
                        <b-form-select-option value="90101500"
                          >Establecimientos para comer y
                          beber</b-form-select-option
                        >
                        <b-form-select-option value="90101800"
                          >Servicios de comida para llevar y a
                          domicilio</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="col-md-4 mb-3"
                      label-class="pb-1"
                      label="Método de Pago"
                    >
                      <b-form-select
                        v-model="cfdi.metodo_pago"
                        size="sm"
                        @change="configStore()"
                      >
                        <b-form-select-option value="01"
                          >Efectivo</b-form-select-option
                        >
                        <b-form-select-option value="04"
                          >Tarjeta de Crédito</b-form-select-option
                        >
                        <b-form-select-option value="28"
                          >Tarjeta de Débito</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                  </b-row>

                  <hr class="mt-0 mb-2" />

                  <b-row>
                    <b-col md="12">
                      <h4 class="text-primary">Mis Tickets</h4>
                    </b-col>
                    <b-form-group
                      class="col-md-4 mb-3"
                      label-class="pb-1"
                      label="Sucursal"
                    >
                      <b-form-select
                        v-model="element.sucursal_id"
                        :disabled="Boolean(tickets.length)"
                        class="text-uppercase"
                        size="sm"
                        @change="configStore"
                      >
                        <b-form-select-option
                          v-for="(sucursal, ks) in sucursales"
                          :key="ks"
                          :value="sucursal.id"
                          >{{ sucursal.nombre }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="col-md-2 mb-3"
                      label-class="pb-1"
                      label="Serie"
                    >
                      <b-form-select
                        :disabled="!element.sucursal_id"
                        size="sm"
                        type="text"
                        placeholder="Serie"
                        v-model="element.serie"
                      >
                        <b-form-select-option
                          v-for="(item, ks) in sucursalSeries"
                          :key="ks"
                          :value="item.serie"
                          >{{ item.serie_public }}</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="col-md-2 mb-3"
                      label-class="pb-1"
                      label="Folio"
                    >
                      <b-form-input
                        :disabled="!element.sucursal_id"
                        size="sm"
                        type="number"
                        placeholder="Folio"
                        class="text-uppercase form-control-solid"
                        step="1"
                        v-model="element.folio"
                        min="0"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      class="col-md-2 mb-3"
                      label-class="pb-1"
                      label="Total"
                    >
                      <b-form-input
                        :disabled="!element.sucursal_id"
                        size="sm"
                        type="number"
                        placeholder="Total"
                        class="text-uppercase form-control-solid"
                        v-model="element.total"
                        min="0"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-2 mb-3">
                      <b-button
                        @click="addTicket"
                        :disabled="working"
                        class="mt-4 py-2"
                        variant="primary"
                        size="sm"
                        block
                        >Agregar Ticket</b-button
                      >
                    </b-form-group>
                    <b-col md="10">
                      <b-table
                        borderless
                        thead-class="text-dark"
                        :fields="fields"
                        :items="tickets"
                        small
                      ></b-table>
                      <hr class="mt-0 mb-2" />
                      <b-button
                        @click="generar"
                        :disabled="!Boolean(tickets.length) || working"
                        variant="success"
                        block
                        >Generar Factura</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      working: false,
      error: [],
      remember: false,
      sucursales: [],
      element: {
        sucursal_id: "",
        serie: "",
        folio: "",
        total: ""
      },
      receptor: {
        nombre: "",
        rfc: "",
        email: ""
      },
      cfdi: {
        uso: "",
        tipo: "",
        metodo_pago: ""
      },
      download: {
        uuid: ""
      },
      fields: [
        {
          key: "fechacreacion",
          label: "Fecha",
          formatter: (value, key, item) => {
            return moment(value)
              .utc()
              .format("DD-MM-YYYY HH:mm:ss");
          }
        },
        {
          key: "numalbaran",
          label: "Folio"
        },
        {
          key: "serie",
          label: "Serie"
        },
        {
          key: "total",
          label: "Total"
        }
      ],
      tickets: []
    };
  },
  watch: {
    remember: function(val) {
      localStorage.setItem("remember", val);
      if (!val) {
        localStorage.removeItem("receptor");
        localStorage.removeItem("cfdi");
        localStorage.removeItem("sucursal");
      } else {
        localStorage.setItem("receptor", JSON.stringify(this.receptor));
        localStorage.setItem("cfdi", JSON.stringify(this.cfdi));
        localStorage.setItem("sucursal", JSON.stringify(this.sucursal));
      }
    }
  },
  computed: {
    sucursalSeries() {
      let sucursal = this.sucursales.find(
        sucursal => sucursal.id == this.element.sucursal_id
      );

      return sucursal ? sucursal.series : [];
    }
  },
  beforeMount() {
    this.remember = localStorage.getItem("remember") == "true";

    this.getSucursales();
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    getSucursales() {
      this.$api
        .get("/facturacion/sucursales")
        .then(response => {
          this.sucursales = response.data;
        })
        .catch(e => console.error(e));
    },
    loadConfig() {
      if (
        localStorage.getItem("remember") != undefined &&
        localStorage.getItem("remember") == "true"
      ) {
        this.receptor = JSON.parse(localStorage.getItem("receptor"));
        this.element.sucursal_id = localStorage.getItem("sucursal");
        this.cfdi = JSON.parse(localStorage.getItem("cfdi"));
      }

      if (localStorage.getItem("facturacion-config") != null) {
        this.params = JSON.parse(data);
      } else {
        this.resetSchemaParams();
      }

      // this.resetElement()
    },
    schemaParams() {
      return {
        remember: false,
        sucursal: "",
        nombre: "",
        rfc: "",
        email: "",
        cfdi_uso: "",
        cfdi_tipo: "",
        cfdi_pago: ""
      };
    },
    schemaElement() {
      return {
        sucursal_id: "",
        serie: "",
        folio: "",
        total: ""
      };
    },
    resetSchemaParams() {
      this.params = this.schemaParams();
    },
    resetElement() {
      this.element = this.schemaElement();
    },
    addTicket() {
      this.working = true;

      this.$api
        .get("/facturacion/ticket/buscar", {
          params: this.element
        })
        .then(res => {
          this.element.folio = "";
          this.element.total = "";
          this.tickets.push(res.data[0]);
        })
        .catch(e => {
          this.$notiflix.Report.failure(
            "Ticket no localizado",
            "Si su compra es reciente, espere unos minutos, y/o valide sus datos."
          );
        })
        .then(() => (this.working = false));
    },
    generar() {
      this.working = true;
      this.error = [];

      this.$api
        .post(`/facturacion/${this.element.sucursal_id}/generar-factura`, {
          receptor: this.receptor,
          cfdi: this.cfdi,
          tickets: this.tickets
        })
        .then(res => {
          this.download = res.data;
        })
        .catch(e => {
          this.error.push(e.response.data);
        })
        .then(() => {
          this.working = false;
        });
    },
    // onSubmit() {
    //   this.error = []
    //   this.working = true;
    //   // this will be called only after form is valid. You can do api call here to login
    //   this.$api
    //     .post("/users/login", this.model)
    //     .then(res => {
    //       this.$store.commit("setSession", res.data);
    //       this.$router.push("dashboard");
    //     })
    //     .catch(e => {
    //       if (e.response) {
    //         this.error.push(e.response.data.errors)
    //       }
    //     })
    //     .then(() => {
    //       this.working = false;
    //     });
    // },
    configStore() {
      if (this.remember) {
        localStorage.setItem("receptor", JSON.stringify(this.receptor));
        localStorage.setItem("cfdi", JSON.stringify(this.cfdi));
        localStorage.setItem(
          "sucursal",
          JSON.stringify(this.element.sucursal_id)
        );
      }
    }
  }
};
</script>
<style lang="scss">
.table {
  thead {
    background: #fefee8;

    tr {
      th {
        padding: 0.25rem 0.75rem;
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 0.25rem 0.75rem;
      }
    }
  }
}
</style>
